import React, { Component } from 'react';
import Heading from '../../common/Heading';
import PurchaseCard from './Card';
import { Link } from 'react-router-dom';
import IntlMessages from '../../../util/IntlMessages';

class MyPurchase extends Component {
  state = {
    purchaseData: [],
  };
  componentDidUpdate(prevProps) {
    if (prevProps.purchase !== this.props.purchase) {
      this.setState({ purchaseData: this.props.purchase });
    }
  }
  render() {
    let { purchaseData } = this.state;
    return (
      <div>
        <div className="d-flex j-space-between">
          <Heading title={<IntlMessages id="app.MyPurchase" />} className="p-0" />
          <Link to="/account/my-purchase" className="textViewAll">
            <IntlMessages id="app.viewallDashboard" />
          </Link>
        </div>
        <div className="sacedSearchBox">
          {purchaseData && purchaseData.length !== 0
            ? purchaseData.map((purchase) => {
                return (
                  <PurchaseCard
                    purchaseData={purchase}

                    // status="Pending" statusClass="pending"
                  />
                );
              })
            : 'No Purchase Data Found'}
          {/* <PurchaseCard status="Cancel" statusClass="cancel" />
          <PurchaseCard status="Pending" statusClass="pending" />
          <PurchaseCard status="Cancel" statusClass="cancel" /> */}
        </div>
      </div>
    );
  }
}
export default MyPurchase;
